import { ValidationErrorResponse } from "../../../services/ValidationError";
import {ServicioGuarderia} from "../../../services/guarderiaServicios";
import {parseCurrency} from "../../../utils/numberUtils";

export interface FormValue {
    wasTouched: boolean,
    isValid: boolean | undefined
}

export interface TextFormValue extends FormValue {
    value: string
}

export interface NumberFormValue extends FormValue {
    value: number | undefined
}

export interface FormState {
    nombre: TextFormValue,
    descripcion: TextFormValue,
    dias: TextFormValue,
    precioTotal: TextFormValue,
    horaSalida: NumberFormValue
}

export const initialFormState: FormState = {
    nombre: { value: "", wasTouched: false, isValid: undefined },
    descripcion: { value: "", wasTouched: false, isValid: undefined },
    dias: { value: "0", wasTouched: false, isValid: undefined },
    precioTotal: { value: "0", wasTouched: false, isValid: undefined },
    horaSalida: { value: 17, wasTouched: true, isValid: undefined }
}

export const resetValidStates = (formState: FormState) => {
    Object.keys(formState).forEach(_key => {
        const currentVal: FormValue = (formState as any)[_key] as FormValue;
        (formState as any)[_key] = { ...currentVal, isValid: undefined };
    });
}

export const invalidateStates = (formState: FormState, validationErrorResponse: ValidationErrorResponse) => {
    Object.keys(validationErrorResponse).forEach(errKey => {
        const errKeyStr = errKey as string;
        const currentVal: FormValue = (formState as any)[errKeyStr] as FormValue;
        (formState as any)[errKeyStr] = { ...currentVal, isValid: false };
    })
}

export const formStateAServicioGuarderia = (id: string, formState: FormState): ServicioGuarderia => {
    return {
        id,
        nombre: formState.nombre.value,
        descripcion: formState.descripcion.value,
        dias: Number.parseInt(formState.dias.value),
        precioTotal: parseCurrency(formState.precioTotal.value, "$", ","),
        horaSalida: formState.horaSalida.value
    }
}

export const servicioGuarderiaAFormState = (servicio: ServicioGuarderia): FormState => {
    return {
        nombre: {value: servicio?.nombre || '', wasTouched: false, isValid: undefined},
        descripcion: {value: servicio?.descripcion || '', wasTouched: false, isValid: undefined},
        dias: {value: servicio?.dias.toString() || '', wasTouched: false, isValid: undefined},
        precioTotal: {value: servicio?.precioTotal.toString() || '', wasTouched: false, isValid: undefined},
        horaSalida: {value: servicio?.horaSalida, wasTouched: false, isValid: undefined},
    };
}